<template>
  <div class="cont-acciones">
    <v-row class="no-gutters">
      <v-col cols="12" class="d-flex wrap row jusfify-center align-center text-center no-gutters">
        <div v-for=" (ac , n) in accionesFiltradas" :key="'ac-'+n" class="item-acciones hvr hvr-scale mx-auto"
        @click="openModal(ac.tipoModal)"
        >
          <img :src="require('@/assets/imagenes_compartidas/icon-cont-'+(n+1)+'.png')" alt="">
          <h2>{{ac.texto}}</h2>
        </div>
      </v-col>
      <v-col cols="12" class="my-3">
        <v-divider></v-divider>
      </v-col>
      <!-- CONTENIDO RIESGOS -->
      <v-col cols="12" class="text-left pa-1" v-if="VerRiesgos">
        <h3>Riesgos:</h3>
        <div v-if="TieneInundacion" class="d-flex pa-3 justify-start align-center hvr hvr-scale item-acciones-riesgos"
        @click="accionRiesgo('inundacion')">
          <div :class="{'activo':$store.state.bVerInundacion}" class="boton-riesgo">
            <img class="" :src="require('@/assets/imagenes_compartidas/icon-riesgos-'+(1)+'.png')" alt="">
          </div>
          <p class="ma-0 pl-1">{{TieneInundacion}}</p>
        </div>
        <div v-if="TieneDeslizamiento" class="d-flex pa-3 justify-start align-center hvr hvr-scale item-acciones-riesgos"
         @click="accionRiesgo('deslizamiento')">
          <div :class="{'activo':$store.state.bVerDeliz}" class="boton-riesgo">
            <img :src="require('@/assets/imagenes_compartidas/icon-riesgos-'+(2)+'.png')" alt="">
          </div>
          <p class="ma-0 pl-1">{{TieneDeslizamiento}}</p>
        </div>
      </v-col>
    </v-row>

    <!-- MODAL HISTORIA -->
    <modal-historia-app v-model="modalHistoria" :fullscreen="false">
      <template slot="modalcontent">
        <infoHistorias :dataHistorias="jsonHistorias" />
      </template>
    </modal-historia-app>
    <!-- MODAL NARRADORES -->
    <modal-narradores-app v-model="modalNarradores" :fullscreen="false">
      <template slot="modalcontent">
        <infoNarradores :dataNarradores="jsonNarradores" />
      </template>
    </modal-narradores-app>
    <!-- MODAL NOTICIAS -->
    <modal-noticias-app v-model="modalNoticias" :fullscreen="false">
      <template slot="modalcontent">
        <infoNoticias :dataNoticias="jsonNoticias" />
      </template>
    </modal-noticias-app>
    <!-- MODAL TRIVIA -->
    <modal-trivia-app v-model="modalTrivia" :fullscreen="false">
      <template slot="modalcontent">
        <infoTrivia :key="keytrivia" :dataTrivia="jsonTrivias" />
      </template>
    </modal-trivia-app>


  </div>
</template>
<script>
import axios from "axios"

import infoNarradores from './infoNarradores'
import infoNoticias from './infoNoticias'
import infoTrivia from './infoTrivia'
import infoHistorias from './infoHistorias'

export default {
  components:{infoNarradores, infoNoticias, infoTrivia, infoHistorias },
  props:{
    TieneInundacion:{
      type: String,
      default: null
    },
    TieneDeslizamiento:{
      type: String,
      default: null
    },
    VerRiesgos:{
      type: Boolean,
      default: true,
    },
    idBarrio:{
      type: String,
      default: '1'
    },
    OcultarNoticias: Boolean,
    OcultarTrivia: Boolean
  },
  data() {
    return {
      jsonTrivias: null,
      jsonNoticias: null,
      jsonHistorias: null,
      jsonNarradores: null,
      modalHistoria: false,
      modalNarradores: false,
      modalTrivia: false,
      modalNoticias: false,
      acciones:[
        {
          tipoModal:'modalHistoria',
          texto:'Historia'
        },
        {
          tipoModal:'modalNarradores',
          texto:'Narradores'
        },
        {
          tipoModal:'modalNoticias',
          texto:'Noticias'
        },
        {
          tipoModal:'modalTrivia',
          texto:'Trivia'
        }
      ],
      keytrivia:0
    }
  },
  computed: {
    accionesFiltradas() {
      return this.acciones.filter(ac => {
        if (this.OcultarNoticias && ac.texto === 'Noticias') return false
        if (this.OcultarTrivia && ac.texto === 'Trivia') return false
        return true
      })
    }
  },
  async mounted() {
    // console.log('acciones contenido')
    // TRIVIAS
    await axios
    .get(''+this.$store.state.rutaApi+'trivias/'+this.idBarrio)
    .then(response => (this.jsonTrivias = response.data))
    // console.log( "jsonTrivias ",this.jsonTrivias)
    // NOTICIAS
    await axios
    .get(''+this.$store.state.rutaApi+'noticias/'+this.idBarrio)
    .then(response => (this.jsonNoticias = response.data))
    // console.log( "jsonNoticas ",this.jsonNoticias)
    // NARRADORES
    await axios
    .get(''+this.$store.state.rutaApi+'narradores/'+this.idBarrio)
    .then(response => (this.jsonNarradores = response.data))
    // console.log( "jsonNarradores ",this.jsonNarradores)
    // HISTORIAS
    await axios
    .get(''+this.$store.state.rutaApi+'historias/'+this.idBarrio)
    .then(response => (this.jsonHistorias = response.data))
    // console.log( "jsonHistorias ",this.jsonHistorias)
  },
  methods: {
    openModal(tipo){
      this.keytrivia++
      // console.log(tipo)
      this[tipo] = true
    },
    accionRiesgo(name){
      this.$emit('accionRiesgo',name)
      if(name === 'inundacion' ){
        this.$store.state.bVerInundacion ? false : true
      }else{
        this.$store.state.bVerDeliz ? false : true
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.activo{
  box-shadow: 1px 2px 4px rgba($color: #000000, $alpha: .5)inset;
  background: rgba($color: #FFFFFF, $alpha: .5);
}
.item-acciones-riesgos{
  .boton-riesgo{
    border-radius: 10px;
    width: 50px;
    height: 50px;
    text-align: center;
    padding: 2px;
    img{
      width: 100%;
    }
  }
}
.cont-acciones{
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
  // flex-wrap: wrap;
  .item-acciones{
    border-radius: 10px;
    width: 100px;
    text-align: center;
    padding: 5px;
    img{
      width: 100%;
    }
    h2{
      font-size: 1em;
      line-height: 1em;
    }
  }
}
</style>
